import { Link } from "react-router-dom"
import { Mail } from "lucide-react"

export function Footer() {
  const links = [
    { href: "/privacy", text: "Privacy Policy" },
    { href: "/terms", text: "Terms of Service" },
    { href: "/cookies", text: "Cookies" },
  ]

  return (
    <footer className="bg-corporate-gray-dark text-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h3 className="text-2xl font-bold mb-4">Orbys360</h3>
          <p className="text-white/80 mb-8">
            The AI-First GCC Platform
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-8 mb-8">
            <div className="flex items-center space-x-2">
              <Mail className="w-4 h-4" />
              <a href="mailto:team@orbys360.com" className="hover:text-white/80 transition-colors">
                team@orbys360.com
              </a>
            </div>
          </div>
          
          {links.length > 0 && (
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
              {links.map((link, index) => (
                <Link
                  key={index}
                  to={link.href}
                  className="text-white/70 hover:text-white transition-colors text-sm"
                >
                  {link.text}
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </footer>
  )
}